// extracted by mini-css-extract-plugin
export default {"container":"OwnerManagerMenu_container__GoxfS","triggerButton":"OwnerManagerMenu_triggerButton__uz8Fm"};